export default __webpack_public_path__ + "static/O0179-d7549b393d70cb8e06e9d15e0444ee6f.png";